import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  RemoveEnergyPerformanceCertificateInput,
  RemoveEnergyPerformanceCertificateMutation,
} from '@/gql/graphql';

const REMOVE_ENERGY_PERFORMANCE_CERTIFICATE_MUTATION = graphql(`
  mutation RemoveEnergyPerformanceCertificate(
    $input: RemoveEnergyPerformanceCertificateInput!
  ) {
    removeEnergyPerformanceCertificate(input: $input)
  }
`);

const useRemoveEnergyPerformanceCertificate = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    RemoveEnergyPerformanceCertificateMutation,
    unknown,
    RemoveEnergyPerformanceCertificateInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(REMOVE_ENERGY_PERFORMANCE_CERTIFICATE_MUTATION, {
        input,
      });
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.overview(args.projectId),
        });
        void queryClient.invalidateQueries({
          queryKey: projectKeys.heatLossEstimate(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useRemoveEnergyPerformanceCertificate;
